module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "up-box"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "drag": "",
      "accept": _vm.accept,
      "action": _vm.actionUrl,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.onSuccess,
      "name": "uploadFile",
      "show-file-list": false,
      "on-error": _vm.onError,
      "on-remove": _vm.onRemove,
      "disabled": !_vm.disabled
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('div', [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.tips))])])]), _vm._v(" "), (_vm.imgUrl) ? _c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39c304b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/UploadDragImg.vue
// module id = 993
// module chunks = 0